import React, { useContext } from 'react';
import { Modal, TabPane } from 'components';
import styled from 'styled-components';
import { hasValidStripeMlsProductId, makeModalResponsive } from 'utils';
import { Redirect } from 'react-router-dom';
import { AuthContext } from 'contexts';
import { AnsweringServiceType } from '@bb/domain/dist/types/AnsweringSubscription';
import AppointmentDeskAlert from './AppointmentDeskAlert';
import NoAccessAlert from '../UserViewPage/Page/PageAlert/NoAccessAlert';
import AppointmentDeskContext, {
  AppointmentDeskStep,
} from './AppointmentDeskContext';
import AppointmentDeskSteps from './AppointmentDeskSteps';
import MyPlan from './MyPlan';
import Activate from './Activate';
import Confirmation from './Confirmation';
import { StyledBodyPane, StyledTabs } from './StyledComponents';
import ManageListings from './ManageListings';

interface AppointmentDeskLayoutProps {
  hasLimitedAccess: boolean;
}

const AppointmentDeskLayout: React.FC<AppointmentDeskLayoutProps> = ({
  hasLimitedAccess,
}) => {
  const { answeringPortalConfig } = useContext(AuthContext);
  const {
    answeringSubscription,
    association,
    currentStep,
    subscriptionExists,
    subscriptionCreated,
    subscriptionType,
    brokerageLaunchDate,
    selectedStartDate,
  } = useContext(AppointmentDeskContext);

  const steps = (!subscriptionExists ||
    !answeringSubscription?.id ||
    subscriptionCreated) && <AppointmentDeskSteps currentStep={currentStep} />;

  const isAppointmentDeskEnhancedActive =
    hasValidStripeMlsProductId(answeringPortalConfig?.mlsProductId) &&
    (association?.useAppointmentDesk || association?.useLiveConciergePlus) &&
    answeringSubscription?.serviceType !==
      AnsweringServiceType.LiveConciergePlus;
  return (
    <>
      {hasLimitedAccess && <NoAccessAlert />}
      <AppointmentDeskAlert
        alertType={subscriptionType}
        currentStep={currentStep}
        isSubscribed={subscriptionExists}
        answeringLaunchDate={
          answeringSubscription?.startDate || selectedStartDate
        }
        brokerageLaunchDate={brokerageLaunchDate}
        timezone={answeringSubscription?.timezone}
      />
      {currentStep === AppointmentDeskStep.ManageListings ? (
        <ManageListings />
      ) : currentStep === AppointmentDeskStep.Confirmation ? (
        <StyledAppointmentDeskTabs defaultActiveKey="1">
          <TabPane tab="Your Plan" key="1">
            <StyledBodyPane $blur={hasLimitedAccess}>
              {steps}
              <Confirmation />
            </StyledBodyPane>
          </TabPane>
          <TabPane tab="Manage Listings" key="2">
            <ManageListings />
          </TabPane>
        </StyledAppointmentDeskTabs>
      ) : isAppointmentDeskEnhancedActive && currentStep === 0 ? (
        <StyledAppointmentDeskTabs defaultActiveKey="1">
          <TabPane tab="Your Plan" key="1">
            <StyledBodyPane>
              <MyPlan />
            </StyledBodyPane>
          </TabPane>
          <TabPane tab="Manage Listings" key="2">
            <ManageListings />
          </TabPane>
        </StyledAppointmentDeskTabs>
      ) : (
        <StyledBodyPane $blur={hasLimitedAccess}>
          {steps}
          {currentStep === 0 && <MyPlan />}
          {currentStep === 1 && <Activate />}
          {currentStep === 2 && <Confirmation />}
        </StyledBodyPane>
      )}
    </>
  );
};

const StyledAppointmentDeskTabs = styled(StyledTabs)`
  min-width: 972px;
`;

export default AppointmentDeskLayout;
